import { get } from '@alltrails/core/utils/get';
import type Experiments from '@alltrails/types/Experiments';

type DeepLinkType = 'download' | 'open' | 'liveshare';

export type NotifyResponse = {
  branchLink: string;
  canReceivePushNotifications: boolean;
  deeplink: DeepLinkType;
  hasAppsFlyer: boolean;
  notificationSent: boolean;
  qrCode: string;
  trailId: number;
  userId: number;
};

type NotifyResponseParams = {
  resourceType: 'trail' | 'park';
  id: number;
  mode: 'send' | 'qrcode';
  deeplinkType: DeepLinkType;
  experiments?: Experiments;
};

export const getNotifyResponse = async ({ resourceType, id, mode, deeplinkType }: NotifyResponseParams) => {
  const params = new URLSearchParams();
  params.set('resource_id', id.toString());
  params.set('resource_type', resourceType);
  params.set('deeplink', deeplinkType);
  params.set('mode', mode);

  return get<NotifyResponse>(`/api/alltrails/notifications/share?${params.toString()}`);
};
